module.exports = __webpack_public_path__ + "static/3-f234f454739cadc9c9a9df4721e8e77c.jpg";